<template>
  <div id="app">
    <TitlePanel />
    <div class="container">
        <iframe  type="text/html"
            src="http://www.youtube.com/embed/ty5106SBa3U?enablejsapi=1&origin=http://example.com"
            frameborder="0">
        </iframe>
    </div>
        <p class='text' id='text-header'>Game Jams</p>
        <p class='text' id='sub-header'>Video lecture</p>
        <p class='text' id='bread-text'>A video I made for a high school where I talk about some projects I've worked on.</p>

    <div style="height:200px;"></div>
    <p id="intro">Projects</p>
    <ProjectPanel v-bind:key=project.header v-for='project in state.projects' v-bind:project='project'/> 
    <Background />
    <footer>
      <h2>Contact</h2>
      <h4>markus@tinnfalt.se</h4>
      <i class="fab fa-linkedin" v-on:click="redirect('https://se.linkedin.com/in/markus-tinnfält-26447390')"></i>
      <i class="fab fa-github-alt" v-on:click="redirect('https://github.com/Tacohej')"></i>
    </footer>
  </div>
</template>

<script>
import TitlePanel from './components/TitlePanel'
import ProjectPanel from './components/ProjectPanel'
import Background from './components/Background'
import projects from './assets/projects.json'

export default {
  name: 'app',
  components: {
    TitlePanel,
    ProjectPanel,
    Background
  },
  data: () => {
    return {
      state: {
        projects: projects
      }
    }
  },
  methods: {
    redirect: (link) => {
      window.open(link)
    }
  }
}
</script>

<style>

#app {
  font-family: 'Comfortaa', cursive;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: normal;
  text-align: center;
  color: white;
}

iframe {
    border: white 5px solid;
    border-radius: 15px;
    width: 90%;
    height: 90%;
}

.container {
    width: 912px;
    height: 513px;
    padding: 0;
    margin: auto;
    overflow: hidden;
}

@media only screen and (max-width: 912px) {
    .container {
        max-width: 640px;
        height: 360px;
    }
}

@media only screen and (max-width: 640px) {
    .container {
        max-width: 400px;
        height: 225px;
    }
}
@media only screen and (max-width: 400px) {
    .container {
        max-width: 320px;
        height: 180px;
    }
}

#intro {
  margin-top: 5rem;
  margin-bottom: 10rem;
  font-size: 4rem;
}

footer {
  padding: 10px;
  text-align: right;
  border-top: 5px white solid;
  color: rgb(206, 206, 206);
  background-color: rgb(20, 20, 20, 0.8);
}

i {
  font-size: 2rem;
  margin: 0.5rem;
  cursor: pointer;
}

i:hover {
  color: white;
}

html, body {
  padding: 0px;
  margin: 0px;
}




#bread-text {
  font-family: 'Source Code Pro', monospace;
}

#text-header {
  font-size: 3rem;
}

#sub-header {
  margin-top: 10px;
  color: orchid;
  font-size: 2rem;
}

.text {
  color: white;
  margin-top: 30px;
  margin-bottom: 10px;
  font-size: 1.2rem;
}

</style>
